import script from "./PasswordRecovery.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordRecovery.vue?vue&type=script&setup=true&lang=js"

import "./PasswordRecovery.vue?vue&type=style&index=0&id=2426c2d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2426c2d0"]])

export default __exports__